import { render, staticRenderFns } from "./NaturalEntityForm.vue?vue&type=template&id=7d870b1c&"
import script from "./NaturalEntityForm.vue?vue&type=script&lang=js&"
export * from "./NaturalEntityForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/otavio.cardoso.neto/Workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d870b1c')) {
      api.createRecord('7d870b1c', component.options)
    } else {
      api.reload('7d870b1c', component.options)
    }
    module.hot.accept("./NaturalEntityForm.vue?vue&type=template&id=7d870b1c&", function () {
      api.rerender('7d870b1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/people/tabs/NaturalEntityForm.vue"
export default component.exports